import { render } from "./dialogBox.vue?vue&type=template&id=090ca80e&scoped=true"
import script from "./dialogBox.vue?vue&type=script&lang=js"
export * from "./dialogBox.vue?vue&type=script&lang=js"

import "./dialogBox.vue?vue&type=style&index=0&id=090ca80e&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090ca80e"]])

export default __exports__